import { __decorate, __metadata } from "tslib";
// NPM
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { OrganizationSettings } from "@/store/modules/organizationSetting.module";
import { SettingModule } from "@/store/modules/settings.module";
import { toaster } from "@/utilities/toaster";
import { setInteractionMode } from "vee-validate";
import { Component, Mixins, Prop } from "vue-property-decorator";
import BaseMixer from "../../BaseMixer";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let logoUploadComponent = /** @class */ (() => {
    let logoUploadComponent = class logoUploadComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.tenantImage = null;
            this.uploadImageLoader = false;
        }
        fileSelected2(e) {
            this.uploadImageLoader = true;
            var newFiles = e.target.files || e.dataTransfer.files;
            if (!newFiles.length) {
                this.uploadImageLoader = false;
                return;
            }
            this.tenantImage = newFiles[0];
            if (this.ImageValidator(this.tenantImage)) {
                if (this.ImageSizeValidator(this.tenantImage)) {
                    this.uploadProfilePicture();
                }
                else {
                    this.uploadImageLoader = false;
                    toaster.ShowError("Please upload a logo which is lesser than 2MB in size.");
                }
            }
            else {
                this.uploadImageLoader = false;
                toaster.ShowError("Please upload a logo with the file format as .jpg, .png or .svg.");
            }
        }
        uploadProfilePicture() {
            let formData = new FormData();
            formData.append("file", this.tenantImage);
            OrganizationSettings.UploadTenantLogo(formData).then((res) => {
                SettingModule.userProfile.tenantLogoUrl = res.tenantLogoUrl;
                this.tenantLogoUrl = res.tenantLogoUrl;
                toaster.ShowSuccess(res.successMessages[0]);
                OrganizationSettings.setTenantLogo(res.tenantLogoUrl);
                this.uploadImageLoader = false;
            });
        }
        created() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], logoUploadComponent.prototype, "tenantLogoUrl", void 0);
    logoUploadComponent = __decorate([
        Component({
            name: "logoUploadComponent",
            components: {
                SectionLoader,
            },
        })
    ], logoUploadComponent);
    return logoUploadComponent;
})();
export default logoUploadComponent;
